import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field } from "redux-form";
import { SimpleField, TextAreaField } from "../../common/Inputs";
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { reviews as reviewsType } from '../../../constants/settingTypes';
import { FileInput } from '../../common/FileInput';
import DateTimeField from "../../common/DateTimeField";
const validate = (values, props) => {
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0|| !values[type] || values[type].trim().length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
        
    }
    if(props.isNew && !values.Image){
        errors.Image = '*Обязательно для заполнения';
    }
    if (!values.TimeAndZone) {
            errors.TimeAndZone = 'Дата обязательна для заполнения';
        }
    required('Title');
    required('Description');
    required('UserName');
    required('Source');

    return errors;
}
class EditModal extends React.Component {
    constructor(props) {

        super(props);
        this.state = {
            Image: props.isNew ? null : `api/settings/${reviewsType}/image/${props.initialValues.ReviewImgId}?t=${new Date().getTime()}`,
        };
        props.initialValues.TimeAndZone = props.isNew ? new Date() : props.initialValues.TimeAndZone
        console.log(props)
        this._onSubmit = this._onSubmit.bind(this);
    }
    _onSubmit(values) {
        this.props.onSubmit(values);
    }
    render() {
        const {
            fetching,
            onClose,
            handleSubmit,
            anyTouched,
            error,
            isNew,
            pristine,
            crudError,
        } = this.props;
        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Добавить отзыв' : 'Редактирование отзыва'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && (
                        <form className="form-horizontal">
                            <Field name="UserName" component={SimpleField} label="Имя" />
                            <Field name="Description" component={TextAreaField} label="Описание" />
                            <Field
                                name="Image"
                                component={FileInput}
                                label="Скрин отзыва"
                                accept=".png, .jpg, .jpeg"
                                onChange={(event, newValue, previousValue, name) => {
                                    const file =  newValue;
                                    if (file) {
                                        const image = URL.createObjectURL(file);
                                        this.setState({ Image: image });
                                    }
                                }}
                            />
                            {<div className="image-container">
                                {this.state.Image && <img src={this.state.Image} alt="Загруженное изображение"/>}
                            </div>}
                            <Field name="Source" component={TextAreaField} label="Источник" />
                            <Field name="TimeAndZone" component={DateTimeField} time={false} label='Дата' dateTimeFormat='DD-MM-YYYY'/>
                            
                        </form>
                    )}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle="info">Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED && <Alert bsStyle="success">УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED && (
                        <Alert bsStyle="danger">
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                    )}
                </Modal.Body>
                {formVisible && (
                    <Modal.Footer>
                        <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)} disabled={pristine}>
                            Сохранить
                        </Button>
                        <Button type="button" onClick={onClose}>
                            Отмена
                        </Button>
                    </Modal.Footer>
                )}
                {closeButtonVisible && (
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        );
    }
}
EditModal = reduxForm({
    form: 'reviewsEdit',
    validate,
})(EditModal);
EditModal = connect((state) => ({
    fetching: state.application.get('settings')[reviewsType].updateFetching,
    crudError: state.application.get('settings')[reviewsType].updateError,
}))(EditModal);
export default EditModal;


// WEBPACK FOOTER //
// ./src/components/settings/reviews/EditModal.jsx